import { Environment } from '@common/models/Enums';
import { LogsInitConfiguration, datadogLogs } from '@datadog/browser-logs';
import {
  DefaultPrivacyLevel,
  RumInitConfiguration,
  datadogRum,
} from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { useEffect } from 'react';

const commonConfig = {
  clientToken: window.RUNTIME_CONFIG?.DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  env: Environment[appEnv.ENV],
};

const rumConfig: RumInitConfiguration = {
  ...commonConfig,
  applicationId: window.RUNTIME_CONFIG?.DATADOG_APPLICATION_ID,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0, // 🚫 disable Session Replay
  defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  plugins: [reactPlugin({ router: true })],
};

const logsConfig: LogsInitConfiguration = {
  ...commonConfig,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
};

export const useDataDog = ({ service }: { service: string }) => {
  useEffect(() => {
    // Return if is already initilalized. Prevents multiple initializations
    if (window.RUNTIME_CONFIG?.DATADOG_INITIALIZED) return;

    // Initialize Datadog RUM
    datadogRum.init({
      ...rumConfig,
      service,
    });

    // Initialize Datadog Logs
    datadogLogs.init({
      ...logsConfig,
      service,
    });

    window.RUNTIME_CONFIG.DATADOG_INITIALIZED = true;
  }, [service]);
};
